<template>
  <div class="container">
    <div class="row pt-4">
      <div class="col-12">
        <p class="header-text text-center">
          Masukan kode OTP yang<br>telah dikirim ke Akun WhatsApp<br>
          <span v-if="$store.state.patient.auth.whatsappNumber">
            {{ $store.state.patient.auth.whatsappNumber.substr(0, 5) }}xxxxxx{{ $store.state.patient.auth.whatsappNumber.substr($store.state.patient.auth.whatsappNumber.length - 3) }}
          </span>
        </p>
      </div>
      <div class="col-12 otp-input-container">
        <client-only>
          <v-otp-input
            ref="otpInput"
            input-classes="otp-input"
            separator="-"
            :num-inputs="4"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-change="handleOnChange"
          />
        </client-only>
      </div>
      <div v-if="message.validation_otp" class="col-12 header-text text-error text-center">
        {{ message.validation_otp }}
      </div>
      <div class="col-12 mt-3">
        <div class="row">
          <div class="col-12">
            <b-button
              size="lg"
              block
              variant="success-2"
              class="border-r25px"
              :disabled="isLoading || otp_input.length < 4"
              @click="handleSubmit()"
            >
              LANJUTKAN
              <b-spinner v-if="isLoading" small label="Small Spinner" variant="light" />
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="isBanned" class="col-12 header-text text-error text-center mt-3">
        Anda telah melampaui limit permintaan pengiriman ulang kode.
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <p v-if="totalTime > 0" class="header-text resent-text mt-4">
              Kirim ulang kode.
              <span>{{ minutes }}</span>:<span>{{ seconds }}</span>
            </p>
            <p v-else class="header-text mt-2 text-center">
              <span @click="doResendOtp()">KIRIM ULANG</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterOtp',
  data () {
    return {
      otp_input: '',
      timer: null,
      totalTime: 120,
      delayTime: 120,
      expired_in: 0,
      message: {
        validation_otp: ''
      },
      isLoading: false,
      epochTime: '',
      isBanned: false
    }
  },

  computed: {
    isStartTime () {
      return this.startTimer()
    },
    minutes () {
      const minutes = Math.floor(this.totalTime / 60)
      return this.padTime(minutes)
    },
    seconds () {
      const seconds = this.totalTime - (this.minutes * 60)
      return this.padTime(seconds)
    }
  },

  mounted () {
    window.scrollTo(0, 0)
    this.startTimer()
    this.checkAllowResend()
  },

  methods: {
    handleSubmit () {
      return this.submitOTP()
    },
    async doResendOtp () {
      if (!this.epochTime) {
        this.totalTime = this.delayTime
      }

      await this.requestOtp()

      return this.startTimer()
    },
    async requestOtp () {
      const token = localStorage.getItem('token')
      await this.$store.dispatch('doctor/resendOtp', token)
        .then((res) => {
          return this.checkAllowResend()
        })
        .catch((err) => {
          if (err.status === 500) {
            this.resetTimer()
            this.message.validation_otp = err.statusText
            return
          }
          return this.checkAllowResend()
        })
    },
    async submitOTP () {
      this.isLoading = true
      let token = ''
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      const payload = {
        Token: token,
        Password: this.otp_input
      }
      await this.$store.dispatch('patient/PhoneVerification', payload)
        .then((res) => {
          localStorage.setItem('token', payload.Token)
          this.isLoading = false
          if (process.client) { window.scrollTo(0, 0) }
          return this.handleNext()
        })
        .catch((err) => {
          if (err.data) {
            this.isLoading = false
            if (err.data.Message === 'RESOURCE_NOT_FOUND') {
              this.message.validation_otp = 'Kode verifikasi tidak sah'
              return
            }
            this.message.validation_otp = err.data.Message
          }
        })
    },

    handleOnChange (value) {
      this.otp_input = value
    },
    resetTimer () {
      clearTimeout(this.timer)
      this.timer = null
    },
    startTimer () {
      this.resetTimer()
      this.countDownTimer()
    },
    padTime (time) {
      return (time < 10 ? '0' : '') + time
    },
    countDownTimer () {
      if (this.totalTime > 0) {
        this.timer = setTimeout(() => {
          this.totalTime -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    handleNext () {
      this.$store.commit('doctor/SET_STEP', 'confirmation')
      localStorage.setItem('step', 'confirmation')
    },
    checkAvailableResend () {
      if (!this.$store.state.doctor.userData) { return }

      this.epochTime = this.$store.state.doctor.userData.BannedTime
      const timesnow = this.$store.state.doctor.userData.Timestamp
      const dateNow = new Date(timesnow * 1000)
      const dateBanned = new Date(this.epochTime * 1000)

      const banned_time = Math.abs((dateBanned - dateNow) / 1000) // get diference time in seconds

      if (banned_time > 0) {
        this.totalTime = banned_time
      }

      return this.startTimer()
    },

    async checkAllowResend () {
      this.isBanned = false
      const token = localStorage.getItem('token')
      await this.$store.dispatch('patient/checkPhoneResend', token)
        .then((res) => {
          if (res.Data) {
            const dateNow = res.Data.CurrentTime
            let dateBanned = 0
            if (res.Data.TimeToResend) {
              if (res.Data.TimeToResend.AvailableAt) {
                dateBanned = res.Data.TimeToResend.AvailableAt
              } else if (res.Data.TimeToResend.BannedAt) {
                dateBanned = res.Data.TimeToResend.BannedAt
              }
            }

            const banned_time = Math.abs(dateBanned - dateNow) // get diference time in seconds

            if (banned_time > 0) {
              if (banned_time > 120) {
                this.isBanned = true
              }
              this.totalTime = banned_time
            }
          }
          return this.startTimer()
        })
    }
  }

}
</script>

<style lang="scss" scoped>
.header-text{
  color: #024668;
  font-size: 20px;
  span{
    font-weight: bold;
  }
}
.btn-next {
  background-color: rgb(0,209,218);
  font-size:20px;
  border:none;
  padding: 12px 0;
  &.disabled{
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
  }
}
.resent-text{
  color: red;
  text-align: center;
}
.text-error{
  color: red;
}

</style>
